import { alpha } from "@commonlibs";
import { css } from "styled-components";
import { getTypographyStyle } from "./util/getTypographyStyle";

export const TextInputStyles = css(
    ({ theme: { spacing, palette, borderRadius, border } }) => css`
        .FormControl {
            .TextInput {
                border: ${border.sm};
                border-radius: ${borderRadius};

                input,
                textarea {
                    height: unset;
                    ::placeholder {
                        color: ${palette.components.input.placeholderColor};
                    }
                    font-size: 16px;
                }

                &.Valid {
                    background-color: ${alpha(palette.status.success, 0.12)};
                }
                &.Invalid {
                    background-color: ${alpha(palette.status.error, 0.12)};
                }

                &.Readonly {
                    input {
                        color: ${palette.gray[300]};
                        cursor: not-allowed;
                    }
                    textarea {
                        color: ${palette.disabled};
                    }
                }

                .suffix,
                .Icon {
                    color: ${palette.components.input.placeholderColor};
                }
            }
        }

        //Size styles
        .FormControl.Sm,
        .FormControl.Md {
            .TextInput {
                input,
                textarea {
                    ${getTypographyStyle("body2Strong")}
                    ::placeholder {
                        ${getTypographyStyle("body2Strong")}
                    }
                }
                .suffix {
                    ${getTypographyStyle("body3Strong")}
                }
                .Icon {
                    font-size: 1.25rem;
                }
            }
        }
        .FormControl.Sm {
            .TextInput {
                padding: ${spacing.all(2, 5)};
            }
        }

        .FormControl.Md {
            .TextInput {
                padding: ${spacing.all(4, 5)};
            }
        }

        .FormControl.Lg {
            .TextInput {
                padding: ${spacing.all(4, 5)};
                input,
                textarea {
                    ${getTypographyStyle("h3Strong")}
                    ::placeholder {
                        ${getTypographyStyle("h3Strong")}
                    }
                }
                .suffix {
                    ${getTypographyStyle("body2Strong")}
                }
                .Icon {
                    font-size: 1.5rem;
                }
            }
        }

        //Variant styles
        .FormControl.Filled {
            .TextInput:not(.Disabled):not(.Valid):not(.Invalid) {
                background-color: ${palette.overlays[800][2]};
            }
        }
    `,
);
